<template>
<section class="data-item">
  <section class="data-item-header">
    <span>{{title}}</span>
  </section>

  <section class="data-item-body" :style="{height:`${bodyHeight}px`}">
    <slot />
  </section>
</section>
</template>

<script>
export default {
  name: 'DataItem',
  props: {
    title: {
      type: String
    },
    downloadBtn: {
      type: Boolean,
      default: false
    },
    bodyHeight: {
      type: Number,
      default: 400
    }
  }
}
</script>

<style lang="scss" scoped>
.data-item {
  .data-item-header {
    line-height: 1.8em;
    padding: 0 10px;
    background: -webkit-gradient(linear, left top, right top, from(#fbc15a), to(#fff));
    background: linear-gradient(to right, #fbc15a 0%, #fff 100%);
    color: #ffffff;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/DataItem.vue